import { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./Seite.css";

// 🔹 массив с данными для schema.org
const videos = [
  {
    name: "Официальный сайт Сергея Мавроди",
    description: "Видеопрезентация официального сайта Сергея Мавроди.",
    thumbnail: "/video/24.avif",
    src: "24.mp4",
    uploadDate: "2024-03-01",
    duration: "PT0M35S", // формат ISO 8601 (пример: PT2M10S = 2 мин 10 сек)
  },
  {
    name: "Предупреждение от Сергея Мавроди",
    description: "Видео с предупреждением Сергея Мавроди о мошенниках.",
    thumbnail: "/video/42.avif",
    src: "42.mp4",
    uploadDate: "2024-03-03",
    duration: "PT0M21S",
  },
];

// Компонент предупреждения
const WarningMessage = () => (
  <div className="main_fon">
    <div className="main_fon_text">
      <div style={{ margin: "0 auto", textAlign: "center" }}>
        <p>
          <span style={{ fontSize: "150%" }}>ПРЕДУПРЕЖДЕНИЕ!</span>
        </p>
        <p>
          <span style={{ fontWeight: "bold", color: "red", fontSize: "117%" }}>
            В настоящее время МММ <br /> не работает в России, Казахстане и Беларуси.
            <br />
            Все сайты в этих странах, выдающие себя за МММ - мошенники!
          </span>
        </p>
        <p>
          <span>В общем, будьте внимательны. Повторяю: это мошенники!</span>
        </p>
        <p>
          <span>Сергей Мавроди</span>
        </p>
        <br />
        <p>
          <span>
            P.S. Напоминаю также в очередной раз, что ни в каких соц.сетях,
            <br />
            твиттерах и пр. меня тоже нет. Всё это обычные прохвосты.
            <br />
            (Чего-то, кстати, расплодившиеся последнее время. :-))
          </span>
        </p>
        <p>
          <span>
            P.P.S. Ни к МММ, ни ко мне лично никакого отношения не имеют.
            <br />
            Обычное жульё. Не попадитесь!
          </span>
        </p>
        <p>
          <span>P.P.P.S. И никаких криптовалют, кстати, я не выпускал.</span>
        </p>
      </div>
    </div>
  </div>
);

// Основной компонент
const Seite = () => {
  const [isFirstVideoLoaded, setIsFirstVideoLoaded] = useState(false);
  const [isSecondVideoLoaded, setIsSecondVideoLoaded] = useState(false);

  return (
    <div className="content">
      <Helmet>
        <title>Официальный сайт Сергея Мавроди: Творчество, Новости, KinoTheater</title>
        <meta
          name="description"
          content="Официальный сайт Сергея Мавроди: новости, творчество, видео, книги и архивные материалы."
        />
        <meta name="keywords" content="Сергей Мавроди, МММ, новости, видео, творчество, книги" />
        <meta name="author" content="Сергей Мавроди" />
        <meta property="og:title" content="Главная - Сергей Мавроди" />
        <meta
          property="og:description"
          content="Официальный сайт Сергея Мавроди: новости, видео, творчество и архив."
        />
        <meta property="og:image" content="https://sergey-mavrodi.com/portrait.webp" />
        <meta property="og:url" content="https://sergey-mavrodi.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ru_RU" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Главная - Сергей Мавроди" />
        <meta
          name="twitter:description"
          content="Официальный сайт Сергея Мавроди: новости, видео, творчество."
        />
        <meta name="twitter:image" content="https://sergey-mavrodi.com/portrait.webp" />
        <link rel="canonical" href="https://sergey-mavrodi.com/" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            'name': 'Главная страница',
            'description': 'Официальный сайт Сергея Мавроди: новости, видео, творчество.',
            'url': 'https://sergey-mavrodi.com/',
            'image': 'https://sergey-mavrodi.com/portrait.webp',
            'publisher': {
              '@type': 'Organization',
              'name': 'Сергей Мавроди',
              'logo': {
                '@type': 'ImageObject',
                'url': 'https://sergey-mavrodi.com/images/logo.webp',
              },
            },
            'breadcrumb': {
              '@type': 'BreadcrumbList',
              'itemListElement': [
                {
                  '@type': 'ListItem',
                  'position': 1,
                  'name': 'Главная',
                  'item': 'https://sergey-mavrodi.com/',
                },
              ],
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(
            videos.map((video) => ({
              '@context': 'https://schema.org',
              '@type': 'VideoObject',
              'name': video.name,
              'description': video.description,
              'thumbnailUrl': `https://sergey-mavrodi.com${video.thumbnail}`,
              'uploadDate': video.uploadDate,
              'duration': video.duration,
              'contentUrl': `https://sergey-mavrodi.com/video/${video.src}`,
              'embedUrl': `https://sergey-mavrodi.com/video/${video.src}`,
              'publisher': {
                '@type': 'Organization',
                'name': 'Сергей Мавроди',
                'logo': {
                  '@type': 'ImageObject',
                  'url': 'https://sergey-mavrodi.com/images/logo.webp',
                },
              },
            }))
          )}
        </script>
      </Helmet>

      <h2>ГЛАВНАЯ СТРАНИЦА</h2>

      {/* КАРТИНКА */}
      <div className="media-container">
        <img
          src="/images/img7.webp"
          alt="Картина Михаила Врубеля «Демон поверженный»"
          title="Михаил Врубель. Демон поверженный"
          className="media-content img7-specific"
        />
      </div>
      

      {/* 🔹 ПЕРВОЕ ВИДЕО */}
      <div className="media-container">
        {!isFirstVideoLoaded ? (
          <div onClick={() => setIsFirstVideoLoaded(true)} className="video-preview">
            <img
              src="/video/24.avif"
              alt="Официальный сайт Сергея Мавроди"
              className="video-thumbnail"
            />
            <svg className="play-button" fill="limegreen" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        ) : (
          <video
            src="/video/24.mp4"
            className="video-player"
            controls
            autoPlay
            playsInline
          />
        )}
      </div>

      {/* 🔹 ВТОРОЕ ВИДЕО */}
      <div className="media-container">
        {!isSecondVideoLoaded ? (
          <div onClick={() => setIsSecondVideoLoaded(true)} className="video-preview">
            <img
              src="/video/42.avif"
              alt="Предупреждение от Сергея Мавроди"
              className="video-thumbnail"
            />
            <svg className="play-button" fill="limegreen" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        ) : (
          <video
            src="/video/42.mp4"
            className="video-player"
            controls
            autoPlay
            playsInline
          />
        )}
      </div>

      {/* 🔹 ПРЕДУПРЕЖДЕНИЕ */}
      <WarningMessage />
    </div>
  );
};

export default Seite;
